(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-atelier-directory"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-bhvd-search]');
    const city = root.querySelector('[data-bhvd-city]');
    const specialty = root.querySelector('[data-bhvd-specialty]');
    const cards = [...root.querySelectorAll('[data-bhvd-card]')];
    const empty = root.querySelector('[data-bhvd-empty]');
    if (!search || !city || !specialty || !cards.length) return;
    const normalized = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const apply = () => {
      const query = normalized(search.value);
      const selectedCity = normalized(city.value);
      const selectedSpecialty = normalized(specialty.value);
      let visible = 0;
      cards.forEach((card) => {
        const matchesQuery = !query || normalized(card.dataset.search).includes(query);
        const matchesCity = !selectedCity || normalized(card.dataset.location).includes(selectedCity);
        const matchesSpecialty = !selectedSpecialty || normalized(card.dataset.specialty).includes(selectedSpecialty);
        card.hidden = !(matchesQuery && matchesCity && matchesSpecialty);
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    };
    search.addEventListener('input', apply);
    city.addEventListener('change', apply);
    specialty.addEventListener('change', apply);
  };
  document.querySelectorAll('[data-bhvd-directory]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-bhvd-directory]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-atelier-featured"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const text = (value) => String(value || '').trim();
  const validProfile = (profile) => profile && text(profile.slug) && text(profile.displayName);
  const safeUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch { return ''; }
  };

  function initialize(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const grid = root.querySelector('[data-featured-grid]');
    const status = root.querySelector('[data-featured-status]');
    const controls = root.querySelector('[data-featured-controls]');
    const position = root.querySelector('[data-featured-position]');
    const pause = root.querySelector('[data-featured-pause]');
    if (!grid || !status || !controls || !position || !pause) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const directoryUrl = safeUrl(root.dataset.directoryUrl) || 'https://pro.barberhunter.com/barbers';
    const intervalMs = Math.max(5, Number(root.dataset.rotationSeconds) || 8) * 1000;
    const labels = root.dataset;
    let month = null;
    let topBarbers = [];
    let start = 0;
    let timer;
    let observer;
    let visible = true;
    let hovering = false;
    let paused = false;
    let destroyed = false;
    let timeout;

    function addText(parent, tag, className, value) {
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = text(value);
      parent.append(element);
      return element;
    }

    function initials(photo, profile) {
      addText(photo, 'span', 'bh-featured-card__initials', text(profile.displayName).split(/\s+/).slice(0, 2).map((part) => part[0]).join(''));
    }

    function barberCard(profile, kind) {
      const card = document.createElement('a');
      card.className = 'bh-featured-card bh-featured-card--' + kind;
      card.href = directoryUrl.replace(/\/$/, '') + '/' + encodeURIComponent(profile.slug);
      const title = kind === 'month' ? labels.labelMonth : labels.labelTop;
      card.setAttribute('aria-label', title + ': ' + text(profile.displayName));
      const photo = document.createElement('span');
      photo.className = 'bh-featured-card__photo';
      photo.setAttribute('aria-hidden', 'true');
      const photoUrl = safeUrl(profile.photoUrl || '');
      if (profile.photoUrl && photoUrl) {
        const image = document.createElement('img');
        image.src = photoUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 240;
        image.height = 240;
        image.addEventListener('error', () => { image.remove(); initials(photo, profile); }, { once: true });
        photo.append(image);
      } else initials(photo, profile);

      card.append(photo);
      const copy = document.createElement('span');
      copy.className = 'bh-featured-card__copy';
      addText(copy, 'span', 'bh-featured-card__title', title);
      addText(copy, 'strong', 'bh-featured-card__name', profile.displayName);
      const where = [profile.city, profile.region].map(text).filter(Boolean).join(', ');
      if (where) addText(copy, 'span', 'bh-featured-card__location', where);
      const specialty = Array.isArray(profile.specialties) ? text(profile.specialties[0]) : '';
      addText(copy, 'span', 'bh-featured-card__verified', '✓ ' + labels.labelVerified + (specialty ? ' · ' + specialty : ''));
      if (kind === 'month') addText(copy, 'span', 'bh-featured-card__cta', labels.labelView + ' →');
      card.append(copy);
      return card;
    }

    function invitation(kind) {
      const card = document.createElement('a');
      card.className = 'bh-featured-card bh-featured-card--' + kind + ' bh-featured-card--placeholder';
      card.href = safeUrl(labels.applyUrl) || 'https://pro.barberhunter.com/#apply';
      const copy = document.createElement('span');
      copy.className = 'bh-featured-card__copy';
      addText(copy, 'span', 'bh-featured-card__title', labels.labelNetwork);
      addText(copy, 'strong', 'bh-featured-card__name', labels.labelInvitation);
      addText(copy, 'span', 'bh-featured-card__location', labels.labelInvitationBody);
      addText(copy, 'span', 'bh-featured-card__verified', labels.labelApply + ' →');
      card.append(copy);
      return card;
    }

    function render(manual = false) {
      const tops = topBarbers.length <= 3 ? topBarbers : [0, 1, 2].map((offset) => topBarbers[(start + offset) % topBarbers.length]);
      const primary = month ? barberCard(month, 'month') : invitation('month');
      const side = document.createElement('div');
      side.className = 'bh-featured__sidebar';
      if (tops.length) addText(side, 'h3', 'bh-featured__other-title', labels.labelOther);
      tops.forEach((profile) => side.append(barberCard(profile, 'top')));
      const join = addText(side, 'a', 'bha-button bha-button--line bh-featured__join', labels.labelJoin + ' →');
      join.href = safeUrl(labels.applyUrl) || 'https://pro.barberhunter.com/#apply';
      grid.replaceChildren(primary, side);
      grid.dataset.cards = String(tops.length + 1);
      position.setAttribute('aria-live', manual ? 'polite' : 'off');
      position.textContent = topBarbers.length > 3
        ? text(labels.labelPosition).replace('[first]', String(start + 1)).replace('[second]', String((start + 2) % topBarbers.length + 1)).replace('[total]', String(topBarbers.length))
        : '';
    }

    function stop() { window.clearInterval(timer); timer = undefined; }
    function syncRotation() {
      stop();
      if (destroyed || motion.matches || paused || hovering || !visible || document.hidden || root.contains(document.activeElement) || topBarbers.length <= 3) return;
      timer = window.setInterval(() => {
        if (root.contains(document.activeElement) || document.hidden) { stop(); return; }
        start = (start + 3) % topBarbers.length;
        render();
      }, intervalMs);
    }
    function move(direction) {
      if (topBarbers.length <= 3) return;
      start = (start + direction * 3 + topBarbers.length) % topBarbers.length;
      render(true);
      syncRotation();
    }
    root.querySelector('[data-featured-previous]')?.addEventListener('click', () => move(-1), options);
    root.querySelector('[data-featured-next]')?.addEventListener('click', () => move(1), options);
    pause.addEventListener('click', () => {
      paused = !paused;
      pause.setAttribute('aria-pressed', String(paused));
      pause.textContent = paused ? labels.labelResume : labels.labelPause;
      syncRotation();
    }, options);
    root.addEventListener('mouseenter', () => { hovering = true; stop(); }, options);
    root.addEventListener('mouseleave', () => { hovering = false; syncRotation(); }, options);
    root.addEventListener('focusin', stop, options);
    root.addEventListener('focusout', () => window.queueMicrotask(syncRotation), options);
    document.addEventListener('visibilitychange', syncRotation, options);
    const syncMotion = () => { pause.hidden = motion.matches; syncRotation(); };
    motion.addEventListener('change', syncMotion, options);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; syncRotation(); }, { threshold: 0 });
      observer.observe(root);
    }
    instances.set(root, () => {
      destroyed = true;
      stop();
      window.clearTimeout(timeout);
      observer?.disconnect();
      controller.abort();
      instances.delete(root);
    });

    const load = async () => {
      try {
        const apiUrl = safeUrl(labels.apiUrl);
        if (!apiUrl) throw new Error('Invalid featured-barber URL');
        timeout = window.setTimeout(() => controller.abort(), 10000);
        const response = await fetch(apiUrl, { headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('Featured-barber service is unavailable');
        const data = await response.json();
        if (destroyed) return;
        month = validProfile(data.barberOfMonth) ? data.barberOfMonth : null;
        const seen = new Set(month ? [text(month.slug)] : []);
        topBarbers = (Array.isArray(data.topBarbers) ? data.topBarbers : []).filter((profile) => {
          if (!validProfile(profile) || seen.has(text(profile.slug))) return false;
          seen.add(text(profile.slug));
          return true;
        });
        if (!month && !topBarbers.length) return;
        status.hidden = true;
        grid.hidden = false;
        controls.hidden = topBarbers.length <= 3;
        pause.hidden = motion.matches;
        render();
        syncRotation();
      } catch {
        if (!destroyed) {
          status.hidden = false;
          grid.hidden = true;
          controls.hidden = true;
        }
      } finally { window.clearTimeout(timeout); }
    };
    load();
  }

  const initializeWithin = (scope) => {
    if (scope.matches?.('[data-bh-featured-barbers]')) initialize(scope);
    scope.querySelectorAll('[data-bh-featured-barbers]').forEach(initialize);
  };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('[data-bh-featured-barbers]')) instances.get(event.target)?.();
    event.target.querySelectorAll('[data-bh-featured-barbers]').forEach((root) => instances.get(root)?.());
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-atelier-system"]) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const normalize = (value) => String(value || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
  function initialize(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    const directories = root.matches?.('[data-atelier-directory]') ? [root] : [...root.querySelectorAll('[data-atelier-directory]')];
    directories.forEach((directory) => {
      const form = directory.querySelector('[data-directory-form]');
      const input = form?.querySelector('input');
      const empty = directory.querySelector('[data-directory-empty]');
      const cards = [...directory.querySelectorAll('[data-directory-card]')];
      if (!form || !input || !cards.length) return;
      const filter = () => {
        const query = normalize(input.value); let count = 0;
        cards.forEach((card) => { card.hidden = !normalize(card.dataset.search).includes(query); if (!card.hidden) count++; });
        if (empty) empty.hidden = count > 0;
      };
      input.addEventListener('input', filter, { signal: controller.signal });
      form.addEventListener('submit', (event) => { event.preventDefault(); filter(); }, { signal: controller.signal });
      form.hidden = false;
    });
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('.bha-faq details[open], .bha-footer details[open]');
      if (details) { details.open = false; details.querySelector('summary')?.focus(); }
    }, { signal: controller.signal });
    controllers.set(root, controller);
  }
  document.querySelectorAll('.shopify-section').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => { controllers.get(event.target)?.abort(); controllers.delete(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
